@if (media) {
  <sd-banner class="is-main" [hasAltText]="false" [media]="media" />
}

<div class="c__content container {{ media ? 'has-media' : ''}} {{ socialLinks?.length ? 'has-social-links' : ''}} {{ showNewsletter ? 'has-newsletter' : ''}}">
  <div class="row justify-content-center">
    @if (showNewsletter) {
      <div class="{{socialLinks?.length > 0 ? 'col-24 col-m-16 offset-l-2 col-l-10 offset-xl-3 col-xl-9' : 'col-24 col-m-16 col-l-10 col-xl-9'}}">
        <sd-newsletter
          [formSuccess]="formSuccess"
          [data]="newsletter"
          [isIntrusive]="isIntrusive"
          [isRow]="isRow"
          [useDQEValidation]="useDQEValidation"
          [formInputValidation]="formInputValidation"
          [suggestions]="suggestions"
          (inputNewsletterValue)="onSubmitNewsletter($event)"
          (validateInput)="ValidateFormInput($event)"
          (inputChanged)="onInputChanged($event)"
        />
      </div>
    }
    @if (socialLinks?.length) {
      <div class="col-24 {{ showNewsletter ? 'offset-l-1 offset-xl-2 col-l-9 col-xl-7' : 'is-alone'}} d-flex align-items-center">
        <sd-social-media [data]="socialLinks" [brand]="brand" />
      </div>
    }
  </div>
</div>
